module.exports = __webpack_public_path__ + "img/73.5215a65e.png";